module.exports = __webpack_public_path__ + "img/Siddharth Dave, Co-President, Schulich Finance Association.c9d7dc0e.webp";